import React, { useState } from 'react';
import MainToolbar from '../MainToolbar';
import { TableContainer, Table, TableRow, TableCell, TableHead, TableBody, makeStyles, IconButton, Paper } from '@material-ui/core';
import t from '../common/localization';
import { useEffectAsync } from '../reactHelper';
import EditCollectionView from '../EditCollectionView';
import EditIcon from '@material-ui/icons/Edit';
import ClearIcon from '@material-ui/icons/Clear';
import { green, blue, red, grey } from '@material-ui/core/colors';
import Avatar from "@material-ui/core/Avatar";
import { showLoaderStateActions } from "./../store";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "material-ui-search-bar";

const useStyles = makeStyles(theme => ({
  columnAction: {
    width: theme.spacing(1),
    padding: theme.spacing(0, 1),
  },
  tableAction: {
    backgroundColor: 'white',
    height: '15px',
  },
  rowAction: {
    backgroundColor: '#361DDB',
    height: '30px',
    padding: '12px',
  },
  iconButtons: {
    display: 'flex',
    margin: theme.spacing(0.5),
  },
  small: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    backgroundColor: '#EFEFEF',
    margin: '2px'
  },
  tableRow: {
    "&$hover:hover": {
      backgroundColor: "#FFFFFF"
    }
  },
  tCell: {
    color: "white", backgroundColor: "#361DDB"
  },
  tContainer: {
    maxHeight: 730
  },
}));

const GroupsView = ({ updateTimestamp, onMenuClick, handleOnEdit, handleOnRemove }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [searchList, setSearchList] = useState([]);

  useEffectAsync(async () => {
    dispatch(showLoaderStateActions.addState(true));

    const response = await fetch('/api/groups');
    dispatch(showLoaderStateActions.addState(false));

    if (response.ok) {
      const res = await response.json();
      setItems(res);
      setSearchList(res);
    }
  }, [updateTimestamp]);

  const searchChange = (val) => {
    const newItems = items.filter((current) => {
      const { name } = current;
      let checkval = `${name || ''}`;
      checkval = checkval.toLowerCase();
      return checkval.includes(val && val.toLowerCase());
    });
    setSearchList(newItems);
  }

  const reset = () => {
    setSearchList(items);
  }

  // no need to sort initially — sort within renderGroupRows

  const renderGroupRows = (groups, parentId = 0, level = 0) => {
    return groups
      .filter(group => group.groupId === parentId)
      .map(group => (
        <React.Fragment key={group.id}>
          <TableRow
            hover
            className={classes.tableRow}
          >
            <TableCell style={{ paddingLeft: `${(level * 20)+10}px` }}>
              <b>{group.name}</b>
            </TableCell>
            <TableCell className={classes.columnAction} padding="none">
              <div className={classes.iconButtons}>
                <Avatar className={classes.small}>
                  <IconButton onClick={() => handleOnEdit(group.id)}>
                    <EditIcon fontSize="small" style={{ color: blue[600] }} />
                  </IconButton>
                </Avatar>
                <Avatar className={classes.small}>
                  <IconButton onClick={() => handleOnRemove(group.id)}>
                    <ClearIcon fontSize="small" style={{ color: grey[450] }} />
                  </IconButton>
                </Avatar>
              </div>
            </TableCell>
          </TableRow>

          {/* Recursively render child groups */}
          {renderGroupRows(groups, group.id, level + 1)}
        </React.Fragment>
      ));
  };

  return (
    <>
      <SearchBar
        onChange={searchChange}
        onCancelSearch={reset}
        placeholder="Search here..."
        className="searchBarInput"
        style={{
          borderRadius: 15,
          height: 35,
          boxShadow: "2px 2px 2px 2px #dbddef",
          fontSize: 12,
          marginBottom: '10px',
          width: "300px"
        }}
      />

      <TableContainer className={classes.tContainer} component={Paper}>
        <Table stickyHeader aria-label="sticky table" className={classes.tableAction} size="small">
          <TableHead>
            <TableRow className={classes.rowAction}>
              <TableCell className={classes.tCell}>{t('settingsGroups')}</TableCell>
              <TableCell className={classes.tCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {renderGroupRows(searchList)}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

const GroupsPage = () => {
  return (
    <>
      <MainToolbar />
      <EditCollectionView
        content={GroupsView}
        editPath="/settings/group"
        endpoint="groups"
        successDialogShow={false}
      />
    </>
  );
}

export default GroupsPage;
